module.exports = __webpack_public_path__ + "img/quan_empty.60e33222.png";